import { IBaseComponentProps, NSBox, NSBoxString, NSInfoProps, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";

export interface ConditionStringLineProps extends IBaseComponentProps
{
    index: number;
    title: string;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: string | null) => void;
    info?: NSInfoProps;
}

export default class ConditionStringLine extends Component<ConditionStringLineProps>
{
    static IS_DIRTY(value: string | null): boolean
    {
        return !!(value && value.trim().length > 0);
    }

    private NSBoxString_Value = createRef<NSBoxString>();

    constructor(props: ConditionStringLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): string | null
    {
        let value = this.NSBoxString_Value.current?.getValue(checkError) ?? null;
        if (!value || !value.trim())
            return null;
        return value.trim();
    }

    setValue(value: string)
    {
        this.NSBoxString_Value.current?.setValue(value);
    }

    isDirty(): boolean
    {
        return ConditionStringLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        return (
            <NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
                <NSBoxString
                    ref={this.NSBoxString_Value}
                    title={`${this.props.title} ${this.props.index + 1}`}
                    required
                    info={this.props.info}
                    onChanged={this.onChanged}
                    menu={{
                        builtin: {
                            delete: {
                                enabled: this.props.deletable,
                                onDelete: this.props.onDelete
                            }
                        },
                        items: []
                    }}
                    style={{ width: NSBox.width.double }}
                />
            </NSRow>
        );
    }
}